export function Logo({ className = "", tam = "sm" }: { className?: string; tam?: "sm" | "lg" }) {
  const emblema = tam === "lg" ? "h-16 w-16" : "h-11 w-11";
  const texto = tam === "lg" ? "text-[1.7rem]" : "text-[1.25rem]";
  return (
    <span className={`inline-flex items-center gap-3 ${className}`} data-testid="tulevik-logo">
      <img
        src="/emblema-tulevik.png"
        alt=""
        aria-hidden="true"
        draggable={false}
        className={`${emblema} select-none object-contain`}
      />
      <span className={`font-brand ${texto} leading-none tracking-[0.14em] text-azul`}>
        TULEVIK <span className="text-salvia-marco">LEGAL</span>
      </span>
    </span>
  );
}
